import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {
  Aangifte, AangifteBerekening,
  AangifteRapport, BokkzAlgDataService, Box1Berekening, IncomeTaxEntity, OpbouwInkomenBox1,
  OpbouwLoon,
  SpecificatieLoon
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, combineLatest} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-loon',
  templateUrl: './overzicht-loon.component.html',
  styleUrls: ['./overzicht-loon.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class OverzichtLoonComponent implements OnInit {

    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    specLoonFormGroup = this.fb.group<AangifteRapport>({});
    specLoon = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specLoonFormGroup = this.fb.group<AangifteRapport>(({
            specificatieLoon: this.fb.group<SpecificatieLoon>(({
                opbouw: this.fb.group<OpbouwLoon>(({
                    belastbaarloon: null as unknown as number,
                    loonUitTegenwoordigeDienstbetrekking: null as unknown as number,
                    loonUitTegenwoordigeDienstbetrekkingBuitenland: null as unknown as number,
                    loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie: null as unknown as number,
                    loonUitVroegereDienstbetrekking: null as unknown as number,
                    loonUitVroegereDienstbetrekkingBuitenland: null as unknown as number,
                    loonUitVroegereDienstbetrekkingInternationaleOrganisatie: null as unknown as number,
                    reisaftrekOpenbaarVervoer: null as unknown as number,
                    vergoedingReisaftrek: null as unknown as number,
                    totaalToegepasteArbeidskorting: null as unknown as number,
                } as OpbouwLoon))
            } as SpecificatieLoon))
        } as AangifteRapport))
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
                    belastbaarloon: null as unknown as number,
                } as OpbouwInkomenBox1)),
            } as Box1Berekening)),
        } as AangifteBerekening))
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity, this.partner]).subscribe(
            ([incomeTaxEntity, partner]) => {
                this.partnerBoolean = partner;
                this.specLoonFormGroup.reset();
                this.berekeningBox1FormGroup.reset();
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.aangifte = aangifte;
                    this.updateForm()
                    this.disableFormGroup(this.specLoonFormGroup);
                    this.disableFormGroup(this.berekeningBox1FormGroup);
                }
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
            this.updateForm();
        }
    }

    private updateForm() {
        if (this.partnerBoolean) {
            this.specLoon=this.partnerRapport;
            this.specLoonFormGroup.patchValue(this.partnerRapport);
            this.berekeningBox1FormGroup.patchValue(this.partnerBerekening)
        } else {
            this.specLoon=this.aangifteRapport;
            this.specLoonFormGroup.patchValue(this.aangifteRapport);
            this.berekeningBox1FormGroup.patchValue(this.berekening)
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}
